import { Table } from 'antd'

import type { ITableProps } from '../types'
import type { IOrganizationData } from './types'

function OrganizationTable({ columns, dataSource, rowKey }: ITableProps<IOrganizationData>): JSX.Element {
  return (
    <Table
      className="organization-table"
      dataSource={dataSource}
      columns={columns}
      rowKey={rowKey}
      pagination={false}
    />
  )
}

export default OrganizationTable
